// const serverName = 'ly-portal/affairs' //接口前缀
const serverName = '' //接口前缀

export default serverName 